import { render, staticRenderFns } from "./WelcomeStepForm.vue?vue&type=template&id=257d1186"
import script from "./WelcomeStepForm.vue?vue&type=script&lang=js"
export * from "./WelcomeStepForm.vue?vue&type=script&lang=js"
import style0 from "./WelcomeStepForm.vue?vue&type=style&index=0&id=257d1186&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports